/**
 * The loadout's frames in their flat order (the order the \`Loadout\`
 * component lays them out and the client addresses them by): each one's
 * key, the equipment group and the index within it that it stands for (how
 * the server and the host store it), and its name as the loadout captions
 * it. What each slot takes is the shared `canEquipInSlot`. Every slot
 * conversion derives from this list.
 */
export const LOADOUT_SLOTS = [
    { key: 'primary', group: 'weapons', groupIndex: 0, label: 'Primary' },
    { key: 'secondary', group: 'weapons', groupIndex: 1, label: 'Off-Hand' },
    { key: 'armor', group: 'armor', groupIndex: 0, label: 'Armor' },
    { key: 'accessory1', group: 'miscellaneous', groupIndex: 0, label: 'Accessory 1' },
    { key: 'accessory2', group: 'miscellaneous', groupIndex: 1, label: 'Accessory 2' },
    { key: 'accessory3', group: 'miscellaneous', groupIndex: 2, label: 'Accessory 3' },
    { key: 'accessory4', group: 'miscellaneous', groupIndex: 3, label: 'Accessory 4' },
] as const;

/** Equipment and accessory frames that can receive an item. `secondary` is the off-hand frame. */
export type LoadoutSlotKey = (typeof LOADOUT_SLOTS)[number]['key'];

/** Each frame's caption, e.g. `Off-Hand`. */
export const LOADOUT_SLOT_LABELS: Readonly<Record<LoadoutSlotKey, string>> = Object.fromEntries(
    LOADOUT_SLOTS.map((slot) => [slot.key, slot.label]),
) as Record<LoadoutSlotKey, string>;

/** Every frame's key, in flat order. */
export const LOADOUT_SLOT_KEYS: readonly LoadoutSlotKey[] = LOADOUT_SLOTS.map((slot) => slot.key);

/** The accessory frames' keys, in order. */
export const ACCESSORY_SLOT_KEYS: readonly LoadoutSlotKey[] = LOADOUT_SLOTS
    .filter((slot) => slot.group === 'miscellaneous')
    .map((slot) => slot.key);
